<template>
  <div class="page-loader">
    <div class="page-loader__context">
      <div class="page-loader__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <title>{{ title }}</title>
          <g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#068b77" stroke="#068b77">
            <g class="nc-loop_circle-02-24" transform="rotate(194.5664285714312 12 12)">
              <circle
                opacity="0.4"
                fill="none"
                stroke="#068b77"
                stroke-miterlimit="10"
                cx="12"
                cy="12"
                r="11"
              />
              <path fill="none" stroke-miterlimit="10" d="M12,1 c6.0751324,0,11,4.9248676,11,11" stroke-linecap="butt" />
            </g>
            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.5s" repeatCount="indefinite" />
          </g></svg>
      </div>
      <span class="data">Loading Contents</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
